export default __webpack_public_path__ + "static/media/lady_img.9bba1790.png";